import React from 'react'
import arrowUp from './img/Expand Arrow_32px.png'
import arrowDown from './img/arrowDown.png'

const FooterColumnHead = props => {
  const title = props.title
  return (
    <div className="footer-head" onClick={ () => props.expandClickHandler(props.uid) }>
      <span className="float-xs-left">{ title } </span>
      <span className="float-right d-xl-none"><img alt={""} src={props.isHidden ? arrowDown : arrowUp} /></span>
    </div>
  )
}

export default FooterColumnHead
